import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { NavLink } from 'react-router-dom';

import type {
  HeaderMenuIconLinkParams,
} from '../types';

export const StyledNavLink = styled(NavLink)(({
  theme: {
    layout,
    colors,
  },
}) => ({
  display: 'flex',
  alignItems: 'center',
  height: layout.HEADER_HEIGHT,
  whiteSpace: 'nowrap',
  color: colors.ACTION_DEFAULT,
  textDecoration: 'none',

  ':hover': {
    color: colors.ACTION_HOVER,
  },

  ':active': {
    color: colors.ACTION_PRESSED,
  },

  '&.n3__active': {
    color: colors.NEUTRAL_DEFAULT,

    ':hover': {
      color: colors.NEUTRAL_DEFAULT,
    },

    ':active': {
      color: colors.NEUTRAL_DEFAULT,
    },
  },
}));

export function HeaderMenuIconLink({
  url,
  renderIcon,
  ...rest
}: HeaderMenuIconLinkParams): ReactElement {
  return (
    <StyledNavLink
      activeClassName="n3__active"
      to={url}
      {...rest}
    >
      {renderIcon()}
    </StyledNavLink>
  );
}
